export const ID_TOKEN_KEY = "id_token";
export const PROFILE_USER = "profile_user";
export const LIST_MENU = "list_menu";
export const USERNAME = "username";
